import type { ReactNode } from "react";
import { getRoleUiForPath } from "../access/RoleUiCatalogue";
import { Navigate, useLocation } from "react-router-dom";
import { RoutePath } from "../constants/RoutePath";
import { useAuth } from "./useAuth";

interface PermissionRouteProps {
  Permission: string;
  Children: ReactNode;
}

export default function PermissionRoute({
  Permission,
  Children,
}: PermissionRouteProps) {
  const { hasPermission, state } = useAuth();
  const location = useLocation();
  const ui = getRoleUiForPath(location.pathname);
  const required =
    state.RoleUis !== undefined && ui ? `${ui.Code}.View` : Permission;

  return hasPermission(required) ? (
    Children
  ) : (
    <Navigate to={RoutePath.Unauthorized} replace />
  );
}
